import { useSessionPermission } from '@btime/react-session'
import React from 'react'

import FixedRoundButton from '../../../components/actions/FixedRoundButton'
import { useOpenEditFormModal } from '../../../utils/routes/modals/modalsActions'

const AddNewButton = () => {
  const hasAddPermission = useSessionPermission('createForm')
  const openEditFormModal = useOpenEditFormModal()
  if (!hasAddPermission) return false

  return <FixedRoundButton onClick={openEditFormModal} />
}

export default AddNewButton
